import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import ReactTable from 'react-table'
import Moment from 'react-moment'
import { IconButton, Tooltip } from '@material-ui/core'
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import { Edit, Delete, Stop } from '@material-ui/icons'
import { MaintenanceTimeContainer } from './styled'
import { AdminContainer } from '../../styled'
import { rootPath, adminPath, configPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'
import { getMaintenanceTimes, deleteMaintenanceTime, markEndMaintenanceTime } from 'ducks/system'
import MaintenanceTimeModal from './FormModal'
import r from 'reactotron-react-js'

const MaintenanceTimes = (props) => {
  const { user, history, listMaintenanceTimes } = props

  useEffect(() => {
    if (listMaintenanceTimes.data.length === 0 && listMaintenanceTimes.loading === false) {
      props.getMaintenanceTimes()
    }
  }, [])

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const [showModal, setShowModal] = useState(false)
  const [editData, setEditData] = useState(undefined)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [deleteId, setDeleteId] = useState(0)
  const [showConfirmEnd, setShowConfirmEnd] = useState(false)
  const [markEndId, setMarkEndId] = useState(0)

  const columns = [
    {
      Header: 'Actions',
      accessor: 'id',
      width: 90,
      Cell: row => (
        row.original.status === 'Ended' ? null : 
          <div className='actionsContent'>
            <Tooltip title='Edit'>
              <IconButton 
                style={{ padding: '10px' }}
                onClick={() => {
                  setEditData(row.original)
                  setShowModal(true)
                }}
              >
                <Edit style={{ fontSize: '1rem' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={row.original.status === 'Upcoming' ? 'Remove' : 'End Immediately'}>
              <IconButton 
                style={{ padding: '10px' }}
                onClick={() => {
                  if (row.original.status === 'Upcoming') {
                    setDeleteId(row.value)
                    setShowConfirmDelete(true)
                  } else {
                    setMarkEndId(row.value)
                    setShowConfirmEnd(true)
                  }
                }}
              >
                {
                  row.original.status === 'Upcoming' ? 
                    <Delete style={{ fontSize: '1rem' }} /> : 
                    <Stop style={{ fontSize: '1rem' }} />
                }
              </IconButton>
            </Tooltip>
          </div>
      )
    }, {
      Header: 'Status',
      accessor: 'status',
      width: 80,
      Cell: row => (
        <div style={{ color: row.value === 'Active' ? 'green' : 'inherit' }}>{row.value}</div>
      )
    }, {
      Header: 'Message',
      accessor: 'message',
    }, {
      Header: 'Start Time',
      accessor: 'startTime',
      width: 130,
      Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-')
    }, {
      Header: 'End Time',
      accessor: 'endTime',
      width: 130,
      Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-')
    }, {
      Header: 'DTGO',
      accessor: 'buyer',
      width: 60,
      style: { textAlign: 'center' },
      Cell: row => (
        row.value ? <Icon icon='check' color='green' /> : <Icon icon='times' color='red' />
      )
    }, {
      Header: 'Vendor',
      accessor: 'seller',
      width: 60,
      style: { textAlign: 'center' },
      Cell: row => (
        row.value ? <Icon icon='check' color='green' /> : <Icon icon='times' color='red' />
      )
    }
  ]

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Maintenance Time</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'Config', content: 'Configuration', link: true, onClick: () => history.push(configPath) },
              { key: 'MaintenanceTimes', content: 'Maintenance Times', active: true }
            ]
          }
        />
      </div>
      <MaintenanceTimeContainer>
        <Button
          type='button'
          content='Create'
          color='blue'
          icon='plus'
          labelPosition='right'
          style={{ marginBottom: '5px' }}
          onClick={() => setShowModal(true)}
        />
        <ReactTable
          data={listMaintenanceTimes.data}
          columns={columns}
          sortable={false}
        />
      </MaintenanceTimeContainer>
      {showModal ? <MaintenanceTimeModal setShowModal={setShowModal} data={editData} /> : null}
      <Confirm 
        open={showConfirmDelete}
        content='Are you sure to Delete this Maintenance Time.'
        onConfirm={() => props.deleteMaintenanceTime(
          deleteId, 
          () => {
            setShowConfirmDelete(false)
            setDeleteId(0)
          })
        }
        onCancel={() => {
          setShowConfirmDelete(false)
          setDeleteId(0)
        }}
      />
      <Confirm 
        open={showConfirmEnd}
        content='Are you sure to End this Maintenance Time.'
        onConfirm={() => props.markEndMaintenanceTime(
          markEndId, 
          () => {
            setShowConfirmEnd(false)
            setMarkEndId(0)
          })
        }
        onCancel={() => {
          setShowConfirmEnd(false)
          setMarkEndId(0)
        }}
      />
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
    listMaintenanceTimes: state.system.listMaintenanceTimes,
  })
}

const mapDispatchToProps = {
  toggleSideMenu,
  getMaintenanceTimes,
  deleteMaintenanceTime, 
  markEndMaintenanceTime
}

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceTimes)